<template>
  <div v-if="$i18n.locale=='zh'">
    <tci-about-us :title='$t("about.interview_page.title")+magazine.year'>
      <v-row v-for="item in magazine.imageUrl" :key="item">
          <v-spacer></v-spacer>
          <v-img :max-width="img_width" :src="item"></v-img>
          <v-spacer></v-spacer>
        </v-row>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
  <div v-else>
    <tci-about-us :title='$t("about.interview_page.title")+magazine_ja.year'>
        <v-row v-for="item in magazine_ja.imageUrl" :key="item">
            <v-spacer></v-spacer>
            <v-img :max-width="img_width" :src="item"></v-img>
            <v-spacer></v-spacer>
        </v-row>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "InterviewMagazine",
  components: {
    "tci-about-us": TciAboutUs,
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    magazines: [
      {"year":"2020","imageUrl":[
              require('../assets/company/c5202009-5.jpg'),
              require('../assets/company/c5202009-6.jpg')
          ]},
      {"year":"2019","imageUrl":[
              require('../assets/company/c5201909-4.jpg'),
              require('../assets/company/c5201909-5.jpg')]},
      {"year":"2019","imageUrl":[require('../assets/company/c5201901-1.jpg')]},
      {"year":"2018","imageUrl":[require('../assets/company/c5201812-1.jpg')]},
      {"year":"2018","imageUrl":[require('../assets/company/c5201811-1.jpg')]},
      {"year":"2018","imageUrl":[require('../assets/company/c5201809-1.jpg'),require('../assets/company/c5201809-2.jpg')]},
      {"year":"2017","imageUrl":[require('../assets/company/c5201704-1.jpg'),require('../assets/company/c5201704-2.jpg')]},
    ],
    magazines_ja: [
        {"year":"2020","imageUrl":[
                require('../assets/company/c5202009-1.jpg'),
                require('../assets/company/c5202009-2.jpg'),
                require('../assets/company/c5202009-3.jpg'),
                require('../assets/company/c5202009-4.jpg')]},
        {"year":"2019","imageUrl":[require('../assets/company/c5201909-1.jpg'),
                require('../assets/company/c5201909-2.jpg'),
                require('../assets/company/c5201909-3.jpg')]},
        {"year":"2019","imageUrl":[require('../assets/company/c5201901-1.jpg')]},
        {"year":"2018","imageUrl":[require('../assets/company/c5201812-1.jpg')]},
        {"year":"2018","imageUrl":[require('../assets/company/c5201811-1.jpg')]},
        {"year":"2018","imageUrl":[require('../assets/company/c5201809-3.jpg'),require('../assets/company/c5201809-4.jpg'),require('../assets/company/c5201809-5.jpg')]},
        {"year":"2017","imageUrl":[require('../assets/company/c5201704-3.jpg'),require('../assets/company/c5201704-4.jpg'),require('../assets/company/c5201704-5.jpg')]},
    ],
    isMobile: false,
    magazine: {},
    magazine_ja: {},
  }),
  computed: {
    img_width: function(){
      if(this.isMobile){
        return window.innerWidth;
      }else{
        return 900;
      }
    }
  },
  mounted(){
    this.magazine = this.magazines[this.$route.params.id]
    this.magazine_ja = this.magazines_ja[this.$route.params.id]
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
